import Timer from './timer/component.vue';

export default {
  name: 'page-pickup',
  props: ['hotlineDetails', 'widgetStyle', 'actualHotlineStatus', 'actualHotlineIcon', 'showIcon'],
  components: {
    'timer': Timer,
  },
  computed: {
    style() {
      return {
        backgroundColor: this.widgetStyle.main_color,
      };
    },
  },
};
